<template>
  <section class="row">
    <div class="col-sm-12">
      <div v-cloak v-if="loaded && !orders.length" class="col-sm-12 text-center">
        <div class="big-message">I'm Empty !!!</div>
        <p class="help-block">Your past orders will appear here once submitted.</p>
      </div>
      <div v-cloak v-if="loaded && orders.length">
        <table class="table table-condensed">
          <thead>
          <tr>
            <th class="th-text text-nowrap">order #</th>
            <th class="th-text text-nowrap">order date</th>
            <th class="th-text text-right">amount</th>
            <th class="th-text">details</th>
          </tr>
          </thead>
          <tbody
                  v-for="(order, index) in orders"
                  :key="order.orderID"
                  class="order-item">
          <tr class="summary" :class="{ 'odd': (index % 2) === 0, 'selected': order.orderID === activeOrderID }" @click.stop.prevent="toggleDetail(order)">
            <td><a href="#">{{ order.orderID  }}</a></td>
            <td>{{ order.datecreated }}</td>
            <td class="text-right">{{ order.finaltotalCurrency }}</td>
            <td>
              <strong>{{order.orderstatus}}</strong><br>
              <span v-if="order.ship_date">Shipped on {{order.ship_date}}<span v-if="order.tracking_url"> with <a @click.stop :href="order.tracking_url" target="_blank">Tracking #{{order.tracking}}</a></span></span>
            </td>
          </tr>
          <transition name="ease">
            <tr v-if="order.orderID === activeOrderID">
              <td colspan="6">
                <order-detail :order="order" class="order-detail"></order-detail>
              </td>
            </tr>
          </transition>
          </tbody>
        </table>
      </div>
    </div>
  </section>
</template>

<style scoped>
.table>tbody+tbody {
  border-top: inherit;
}
.summary {
  cursor: pointer;
}
.summary:hover {
  background-color: #d9d9d9;
}
.odd {
  background-color: #f9f9f9;
}
.summary.selected, .summary.selected a {
  font-weight: bold;
  color: #fff;
  background-color: #990033;
}
.order-detail {
  margin-left: 15px;
  margin-bottom: 15px;
}
</style>

<script>
import axios from 'axios'
import { jrNotifyEx } from '../../bootstrap'
import OrderDetail from './OrderDetail'

export default {
    components: {
        'order-detail': OrderDetail,
    },

    props: {
        initialOrders: {
            type: Object,
            default: {},
        }
    },

    data () {
        return {
            loaded: false,
            orders: [],
            activeOrderID: null
        }
    },

    async created () {
        if (this.initialOrders && this.initialOrders.data) {
            this.orders = this.initialOrders.data
            this.loaded = true
        } else {
            this.fetchOrderList()
        }
    },

    methods: {
        toggleDetail: function (order) {
            if (this.activeOrderID === order.orderID) {
                this.activeOrderID = null
            } else {
                this.activeOrderID = order.orderID
            }
        },

        fetchOrderList: async function() {
            try {
                const response = await axios.get("/order")
                this.orders = response.data.data
                this.loaded = true
            } catch (e) {
                jrNotifyEx(e)
            }
        },
    }
}
</script>
